export default function CurrentIdi({ next, router }) {
	if(!localStorage.getItem('token')) {
		return router.push({ name: 'Login'})
	}

	if (!localStorage.getItem('current_idi') || localStorage.getItem('current_idi') == 'undefined' || localStorage.getItem('current_idi') == 'null') {
		return router.push({ name: 'select' });
	}

  return next();
}